export const EMPLOYEE_EXCEL_SCHEMA = Object.freeze([
  { key: "nameOrNum", type: "string" },
  { key: "yearOfBirth", type: "number" },
  { key: "employmentGrade", type: "number" },
  { key: "sex", type: "option", optionField: "sex" },
  { key: "employmentLevel", type: "option", optionField: "employmentLevel" },
  { key: "employmentStatus", type: "option", optionField: "employmentStatus" },
  { key: "specXFunc", type: "option", optionField: "specXFunc" },
  { key: "emplStartDate", type: "date", required: false },
  { key: "emplEndDate", type: "date", required: false },
  { key: "employmentType", type: "option", optionField: "employmentType" },
  { key: "baseSalary", type: "number" },
  { key: "addBenefits", type: "number" },
  { key: "nominalAttendanceTime", type: "number" },
  { key: "yearlyPresenceTime", type: "number" },
  { key: "educationTraining", type: "number" },
  { key: "advertisingAcquisition", type: "number" },
  { key: "contest", type: "number" },
  { key: "managementLeadership", type: "number" },
  { key: "edvOperation", type: "number" },
  { key: "others", type: "number" },
  { key: "remarks", type: "string", required: false },
]);
